export enum UiDataParams {
  uiEnrichments = 'uiEnrichments',
}

export const SUBSCRIPTION_ACESS_ERROR_MESSAGES = [
  `Your subscription plan doesn't cover this insight.`,
  'Your subscription does not allow you to see any data, please contact your GfK representative.',
];

export const DEFAULT_LOCALE = 'en-GB';

export const MOBILE_POC_FEATURE_TAG = 'mobile-poc';

export const BULK_EXPORT_URL = '/bulk-export';
